type EmptyStateProps = {
  title: string;
  body: string;
};

export function EmptyState({ title, body }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <div className="empty-state-badge">CRM</div>
      <h3>{title}</h3>
      <p>{body}</p>
    </div>
  );
}
